<template>
  <div>
    <el-dialog :visible.sync="dialogVisible"
               custom-class="vip-dialog"
               @close="close"
               width="850px">
      <template v-if="showContent">
        <slot name="aside">
          <div class="aside-area">
            <span class="right-title">会员权益</span>
            <div class="right-list">
              <span class="list-item"><img src="../assets/pay-dialog-circle.png" />消费者洞察</span>
              <span class="list-item"><img src="../assets/pay-dialog-circle.png" />市场调研</span>
              <span class="list-item"><img src="../assets/pay-dialog-circle.png" />竞品分析</span>
              <span class="list-item"><img src="../assets/pay-dialog-circle.png" />产品研究</span>
            </div>
          </div>
        </slot>
        <div class="right-area">
          <div class="pay-shutdown-area">
            <div class="area-header">
              <i></i><span>温馨提示</span>
            </div>
            <p>由于产品策略调整，镜界AI已停止订阅，</p>

            <p>未来会作为<a style="color: blue;text-decoration: none;"
                 href="https://www.mktindex.com/"
                 target="_blank">魔镜CMI</a>之平台一部分为客户提供服务</p>
            <p>感谢您的理解与支持！</p>

            <div class="book-demo-qr">
              <p>魔镜CMI平台，整合销售、评论、社媒三大数据源，助力市场研究和消费者洞察。</p>
              <img :src="qrCode"
                   alt="">
              <p>扫码预约演示</p>

            </div>
          </div>
          <!-- <slot>
            <div class="title-area">
              <span class="title">会员详情</span>
              <span class="sub-title">/ 您的提问额度已用完，即刻充值，继续和魔镜AI一起高效洞察市场！</span>
              <div style="float: right">
                <el-button size="mini"
                           style="background: #b73624;color: #fff;border-radius: 5px"
                           @click="jumpToInvite"><i class="el-icon-present"
                     style="font-size: 14px;margin-right: 5px;"></i>免费领取提问机会</el-button>
              </div>
            </div>
            <div class="recharge-area">
              <div class="recharge-card"
                   v-for="(item,index) in writingList"
                   :key="item.id"
                   :class="{active: activeId == item.id, month: index == 0, year: index== 1}"
                   @click="cardChange(item.id)">
                <div class="card-area"
                     v-if="index == 0">
                  <div class="card-tag">月度使用</div>
                  <div class="price">
                    <span class="unit">{{item.unit}}</span>
                    <span class="number">{{item.number}}</span>
                    <span class="time">/月</span>
                  </div>
                  <div class="sub-price-area">
                    <div class="sub-price">
                      限时优惠
                    </div>
                  </div>
                  <div style="color: #cacaca;letter-spacing: 1px;font-size: 10px;text-align: center;margin: 5px 0">
                    有效期31天内最多提问100次
                  </div>
                </div>
                <div class="card-area"
                     v-if="index == 1">
                  <div class="card-tag">年度使用</div>
                  <div class="price">
                    <span class="unit">{{item.unit}}</span>
                    <span class="number">82.5</span>
                    <span class="time">/月</span>
                  </div>
                  <div class="sub-price-area">
                    <div class="sub-price">
                      最受欢迎｜节省<span style="font-weight: bolder">17%</span>
                    </div>
                  </div>
                  <div style="color: #cacaca;letter-spacing: 1px;font-size: 10px;text-align: center;margin: 5px 0">
                    有效期365天内最多提问1200次
                  </div>
                </div>
              </div>
              <div class="recharge-card"
                   @click="jumpToInvite">
                <div class="card-area">
                  <div class="card-tag"
                       style="background: #334BF5;color: #fff;font-weight: 400">邀请有礼</div>
                  <div style="width: 100%;display: flex;justify-content: center;margin-top: 20px;margin-bottom: 5px">
                    <img src="../assets/gift.png"
                         style="height: 80px"
                         alt="">
                  </div>
                  <div style="color: #cacaca;letter-spacing: 1px;font-size: 10px;text-align: center;">
                    邀请新用户立享·额外免费提问
                  </div>
                </div>
              </div>
            </div>
            <div class="QR-code-area">
              <div class="content"
                   v-loading="QRLoading">
                <div id="wechat-qrcode"
                     v-show="tab == 'wechat' && agreementChecked"
                     width="100px"
                     alt="微信付款码">
                </div>
                <img :src="qrCode"
                     alt=""
                     style="width: 100px; height: 100px"
                     v-show="!agreementChecked">
                <div class="content-pay-area">
                  <i class="iconfont icon-weixinzhifu1"
                     style="color: #57b050"></i>
                  <span style="color: #2D2D2D">微信支付</span>
                </div>
              </div>
              <div class="content-desc">
                <div class="pay-desc">
                  <span class="word">微信支付:</span>
                  <span class="unit">¥</span>
                  <span class="number">{{activeId == '1' ? '99' : '990'}}</span>
                </div>
                <div class="sub-desc">
                  <span>使用微信扫码付款</span>
                </div>
              </div>
            </div>
          </slot>
          <slot name="footer">
            <div class="product-area">
              <div style="margin-bottom: 20px">
                <el-link href="https://qmctsz2s8t.feishu.cn/docx/NdaOdC8MPo4gi8xk76ZcXD3Unre"
                         type="primary"
                         target="_blank"
                         style="font-size: 12px">【魔镜·镜界AI】产品使用文档</el-link>
              </div>
              <el-popover placement="bottom-start"
                          trigger="hover">
                <div style="width: 200px; height:200px">
                  <img style="width: 200px"
                       src="../assets/JessieCode.jpeg"
                       alt=""
                       v-if="!kfImg">
                  <img style="width: 100%;height: 100%"
                       :src="kfImg"
                       alt=""
                       v-if="kfImg">
                </div>
                <span class="text"
                      slot="reference">对产品有疑问？联系镜界AI产品经理</span>
              </el-popover>
            </div>
            <div class="footer-area"
                 style="margin-top: 10px; letter-spacing: 1px;">
              <el-checkbox v-model="agreementChecked"
                           style="font-size: 12px">勾选即代表同意会员服务协议
                <el-link href="https://ai.mktindex.com/member.txt"
                         style="height: 20px;line-height: 20px; font-size: 12px; margin-top: -3px"
                         type="primary"
                         target="_blank">《镜界AI会员服务协议》</el-link>
              </el-checkbox>
            </div>
          </slot> -->
        </div>

      </template>
      <template v-if="showSuccess">
        <div class="payment-success">
          <h1 style="color:#4caf50"><i class="el-icon-circle-check"></i>支付成功!</h1>
          <p>立刻继续和镜界AI一起高效洞察市场，把握商机吧！</p>
          <p> 您可以随时在页面左下角“设置”中查看账号到期时间和问题记录~
          </p>
          <div class="success-actions">
            <button @click="goToHome">我知道了</button>
          </div>
        </div>
      </template>
      <template v-if="showFail">
        <div class="payment-failure">
          <h1 style="color: #f44336"><i class="el-icon-circle-close"></i>支付失败</h1>
          <p>很遗憾，您的付款无法处理。请再试一次。</p>
          <div class="actions">
            <button @click="retryPayment">重试</button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import QRCode from 'qrcode'
export default {
  name: 'VipDialog',
  data() {
    return {
      dialogVisible: false,
      activeId: 0,
      // 付费选项
      writingList: [],
      QRLoading: false,
      tab: 'wechat',
      showContent: true,
      showSuccess: false,
      showFail: false,
      payId: '',
      payInterval: '',
      // 协议同意
      agreementChecked: true,
      qrCode: require('../assets/book-qr-code.jpg'),
      getOrderListInterval: null,
    }
  },
  props: {
    getOrderListPromise: {
      type: Function,
      default: () => null,
    },
    getPayDetail: {
      type: Function,
      default: () => null,
    },
    queryPay: {
      type: Function,
      default: () => null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: '',
    },
    yearOrderId: {
      type: String,
      default: '',
    },
  },
  computed: {
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
    kfImg() {
      return this.$store.state.user.kfImgUrl
    },
  },
  methods: {
    jumpToInvite() {
      this.$eventBus.$emit('jumpToInvite')
    },
    cardChange(id) {
      this.activeId = id
      const orderId = id == '1' ? this.orderId : this.yearOrderId
      if (!orderId) {
        // orderId 为空则不请求
        this.$message.error('请求订单失败,请刷新页面重试')
        return
      }
      this.QRLoading = true
      const host = window.location.hostname
      const domain = host.split('.')[0]
      this.getPayDetail({
        order_type: id,
        order_id: orderId,
        username: this.loginInfo.username,
        app_id: domain,
      })
        .then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            this.generateQR('wechat', result.code_url)
            this.payStatusInterval()
            this.QRLoading = false
          }
        })
        .catch((err) => {
          this.QRLoading = false
          console.log(err)
        })
    },
    generateQR(plat, url) {
      switch (plat) {
        case 'wechat': {
          const existingCanvas = document.getElementById('wechat-canvas')
          if (existingCanvas) {
            existingCanvas.remove()
          }
          const canvas = document.createElement('canvas')
          canvas.id = 'wechat-canvas'
          QRCode.toCanvas(canvas, url, { width: 100 }, (error) => {
            if (error) console.error(error)
            document.getElementById('wechat-qrcode').appendChild(canvas)
          })
          break
        }
      }
    },
    // 支付状态轮询
    payStatusInterval(payId) {
      if (this.payInterval) {
        clearInterval(this.payInterval)
        this.payInterval = ''
      }
      if (!this.orderId || !this.yearOrderId) {
        this.$message.error('请求订单失败,请刷新页面重试')
        return
      }
      this.payInterval = setInterval(() => {
        const orderId = this.activeId == '1' ? this.orderId : this.yearOrderId

        if (!orderId) {
          return
        }
        this.queryPay({
          order_id: orderId,
          username: this.loginInfo.username,
        })
          .then((res) => {
            if (res.status == 'ok') {
              const result = res.result
              const tradeState = result.state
              if (tradeState == 'SUCCESS') {
                this.changePayStatus('success')
              }
            }
          })
          .catch((err) => {
            this.changePayStatus('error')
          })
      }, 500)
      // setTimeout(() => {
      //   this.changePayStatus('error')
      // }, 10000)
    },
    changePayStatus(type) {
      switch (type) {
        case 'success':
          {
            clearInterval(this.payInterval)
            this.payInterval = ''
            if (!this.showSuccess) {
              // 如果本身就在支付成功页面, 说明已经支付成功, 就不需要发送事件了.
              this.$emit('on-paySuccess')
            }
            this.showSuccess = true
            this.showContent = false
            this.showFail = false
          }
          break
        case 'error':
          {
            clearInterval(this.payInterval)
            this.payInterval = ''
            this.showSuccess = false
            this.showContent = false
            this.showFail = true
            this.$emit('on-payError')
          }
          break
      }
    },
    goToHome() {
      this.dialogVisible = false
    },
    retryPayment() {
      this.dialogVisible = false
      setTimeout(() => {
        this.dialogVisible = true
      }, 500)
    },
    close() {
      this.showContent = true
      this.showSuccess = false
      this.showFail = false
      this.$emit('payDialogClose')
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    tab(newVal) {
      console.log(newVal)
    },
    dialogVisible: {
      handler(newVal) {
        const host = window.location.hostname
        const domain = host.split('.')[0]
        // if (newVal) {
        //   this.QRLoading = true
        //   if (this.getOrderListPromise) {
        //     if (!this.yearOrderId || !this.orderId) {
        //       // orderId 为空则不请求
        //       this.$message.error('请求订单失败,请刷新页面重试')
        //       return
        //     }
        //     this.getOrderListPromise({
        //       order_id: this.orderId,
        //       username: this.loginInfo.username,
        //       year_order_id: this.yearOrderId,
        //       app_id: domain,
        //     })
        //       .then((res) => {
        //         this.QRLoading = false
        //         if (res.status == 'ok') {
        //           const result = res.result
        //           this.writingList = result.order_type_list.map((item) => {
        //             const temp = {
        //               unit: '¥',
        //               title: item.desc,
        //               number: (item.amount / 100).toFixed(0),
        //               amount: item.amount,
        //               id: item.order_type,
        //               code_url: item.code_url,
        //             }
        //             return temp
        //           })
        //           // this.activeId = this.writingList[0].id

        //           if (this.writingList[1] && this.activeId == 0) {
        //             this.activeId = this.writingList[1].id
        //             this.generateQR('wechat', this.writingList[1].code_url)
        //           } else {
        //             console.log('getOrderListPromise update')
        //             const item = this.writingList.find(
        //               (ele) => ele.id == this.activeId
        //             )
        //             if (item) {
        //               this.generateQR('wechat', item.code_url)
        //             }
        //           }
        //           // else {
        //           //   this.writingList.push({
        //           //     unit: '¥',
        //           //     title: 1,
        //           //     number: 1,
        //           //     amount: 1,
        //           //     id: 123123,
        //           //   })
        //           //   this.activeId = this.writingList[1].id
        //           // }
        //           // this.payId = this.writingList[0].id
        //           // this.payStatusInterval()
        //         }
        //       })
        //       .catch((err) => {
        //         this.QRLoading = false
        //       })
        //     this.getOrderListInterval = setInterval(() => {
        //       this.getOrderListPromise({
        //         order_id: this.orderId,
        //         username: this.loginInfo.username,
        //         year_order_id: this.yearOrderId,
        //         app_id: domain,
        //       })
        //         .then((res) => {
        //           this.QRLoading = false
        //           if (res.status == 'ok') {
        //             const result = res.result
        //             this.writingList = result.order_type_list.map((item) => {
        //               const temp = {
        //                 unit: '¥',
        //                 title: item.desc,
        //                 number: (item.amount / 100).toFixed(0),
        //                 amount: item.amount,
        //                 id: item.order_type,
        //                 code_url: item.code_url,
        //               }
        //               return temp
        //             })
        //             // this.activeId = this.writingList[0].id

        //             if (this.writingList[1] && this.activeId == 0) {
        //               this.activeId = this.writingList[1].id
        //               this.generateQR('wechat', this.writingList[1].code_url)
        //             } else {
        //               console.log('getOrderListPromise update')
        //               const item = this.writingList.find(
        //                 (ele) => ele.id == this.activeId
        //               )
        //               if (item) {
        //                 this.generateQR('wechat', item.code_url)
        //               }
        //             }
        //             // else {
        //             //   this.writingList.push({
        //             //     unit: '¥',
        //             //     title: 1,
        //             //     number: 1,
        //             //     amount: 1,
        //             //     id: 123123,
        //             //   })
        //             //   this.activeId = this.writingList[1].id
        //             // }
        //             // this.payId = this.writingList[0].id
        //             // this.payStatusInterval()
        //           }
        //         })
        //         .catch((err) => {
        //           this.QRLoading = false
        //         })
        //     }, 600000) //10min
        //   }
        // } else {
        //   if (this.payInterval) {
        //     clearInterval(this.payInterval)
        //     this.payInterval = ''
        //   }
        //   if (this.getOrderListInterval) {
        //     clearInterval(this.getOrderListInterval)
        //     this.payInterval = null
        //   }
        //   this.showContent = true
        //   this.showSuccess = false
        //   this.showFail = false
        // }
      },
      immediate: true,
    },
    activeId: {
      handler(newVal) {
        if (newVal != 0) {
          this.payStatusInterval(newVal)
        }
      },
      immediate: true,
    },
  },
  created() {},
}
</script>

<style lang="less">
.el-dialog__wrapper {
  .vip-dialog {
    font-family: MicrosoftYaHei;
    border-radius: 30px;
    width: 100%;
    background: linear-gradient(180deg, #c9dbff 0%, #ecf2fe 15%, #ffffff 100%);
    .pay-shutdown-area {
      height: 300px;
      .area-header {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          background-image: url('../assets/tooltip.png');
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 3px;
          margin-right: 8px;
        }
        span {
          font-size: 22px;
          font-weight: bolder;
          color: black;
          font-family: MicrosoftYaHei;
        }
      }
      p {
        color: #2d2d2d;
        font-size: 16px;
        margin: 0;
        margin-bottom: 2px;
        font-family: MicrosoftYaHei;
        text-align: center;
      }

      .book-demo-qr {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        flex-direction: column;
        align-items: center;
        img {
          width: 150px;
          margin-bottom: 15px;
        }
        p {
          color: #666;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .desc {
          color: #666;
          font-size: 12px;
          margin-bottom: 10px;
        }
      }
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      display: flex;
      padding: 0;
      border-radius: 30px;
      .aside-area {
        flex-basis: 300px;
        border-radius: 30px 0 0 30px;
        background-color: #334bf5;
        padding-top: 60px;
        letter-spacing: 2px;
        .right-title {
          display: inline-block;
          width: 100%;
          font-size: 22px;
          color: white;
          text-align: center;
        }
        .right-list {
          display: flex;
          flex-direction: column;
          letter-spacing: 4px;
          color: #fffefe;
          font-size: 14px;
          padding-left: 40px;
          margin-top: 25px;
          font-weight: 100;
          .list-item {
            color: #fffefe;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            img {
              width: 8px;
              height: 8px;
              margin-right: 20px;
            }
          }
        }
      }
      .right-area {
        padding: 25px;
        padding-top: 50px;
        width: 100%;
        height: 370px;
        .title-area {
          .title {
            color: #2d2d2d;
            font-size: 18px;
            margin-right: 15px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            letter-spacing: 1px;
          }
          .sub-title {
            font-size: 12px;
            letter-spacing: 1px;
          }
        }
      }
      // border-radius: 50%;
      .recharge-area {
        margin-top: 20px;
        display: flex;
        .recharge-card {
          background: white;
          border: 1px solid #e1e1e1;
          border-radius: 12px;
          cursor: pointer;
          // height: 140px;
          position: relative;
          width: 165px;
          margin-left: 20px;
          padding: 10px 5px;
          .card-area {
            // left: 50%;
            // position: absolute;
            // top: 50%;
            // transform: translate(-50%, -50%);
            // width: 100%;
            // padding-top: 30px;
            .card-tag {
              position: absolute;
              top: -1px;
              left: -1px;
              border-radius: 8px 0 8px 0;
              color: #fff;
              width: 80px;
              text-align: center;
              background: linear-gradient(to right, #334bf5, #1e3aff);
              font-size: 12px;
              height: 26px;
              line-height: 26px;
              font-weight: bolder;
            }
            .title {
              font-size: 18px;
              color: #2d2d2d;
              text-align: center;
              font-weight: bold;
              letter-spacing: 1px;
            }
            .sub-title {
              margin-top: 30px;
              text-align: center;
              font-size: 10px;
              text-decoration: line-through;
              color: #cacaca;
              letter-spacing: 1px;
            }
          }
          // .title {
          //   -webkit-text-fill-color: transparent;
          //   background-clip: text;
          //   -webkit-background-clip: text;
          //   background-image: linear-gradient(
          //     281.06deg,
          //     #813803 4.09%,
          //     #58290a 117.55%
          //   );
          //   font-size: 15px;
          //   font-weight: 500;
          //   margin-bottom: 4px;
          //   text-align: center;
          // }
          .price {
            margin-bottom: 4px;
            text-align: center;
            margin-top: 30px;
            .unit {
              color: #2f4eff;
              font-size: 18px;
              font-weight: 500;
              line-height: 25px;
              margin-right: 4px;
              font-weight: bolder;
            }
            .number {
              color: #2f4eff;
              font-size: 34px;
              font-weight: bolder;
              line-height: 40px;
              letter-spacing: 2px;
              font-weight: bolder;
            }
            .time {
              letter-spacing: 2px;
            }
          }
          .sub-price-area {
            width: 100%;
            display: flex;
            justify-content: center;
            .sub-price {
              width: 80px;
              background-color: #ebedff;
              font-size: 12px;
              color: #436bfa;
              text-align: center;
              height: 26px;
              line-height: 26px;
              letter-spacing: 1px;
              border-radius: 13px;
              padding: 0 5px;
            }
          }
          .rights-list {
            color: #7f7f7f;
            font-size: 12px;
            width: 100%;
            text-align: center;
            margin: 10px 0;
          }
        }
        .recharge-card.year {
          .card-area {
            // left: 50%;
            // position: absolute;
            // top: 50%;
            // transform: translate(-50%, -50%);
            // width: 100%;
            // padding-top: 30px;
            .card-tag {
              position: absolute;
              top: -1px;
              left: -1px;
              border-radius: 8px 0 8px 0;
              color: #fff;
              width: 80px;
              text-align: center;
              background: linear-gradient(to right, #ff874f, #ff7300);
              font-size: 12px;
              height: 26px;
              line-height: 26px;
              font-weight: bolder;
            }
            .title {
              font-size: 18px;
              color: #2d2d2d;
              text-align: center;
              font-weight: bold;
              letter-spacing: 1px;
            }
            .sub-title {
              margin-top: 30px;
              text-align: center;
              font-size: 10px;
              text-decoration: line-through;
              color: #cacaca;
              letter-spacing: 1px;
            }
          }
          .price {
            margin-bottom: 4px;
            text-align: center;
            margin-top: 30px;
            .unit {
              color: #ff5f00;
              font-size: 18px;
              font-weight: 500;
              line-height: 25px;
              margin-right: 4px;
              font-weight: bolder;
            }
            .number {
              color: #ff5f00;
              font-size: 34px;
              font-weight: bolder;
              line-height: 40px;
              letter-spacing: 2px;
              font-weight: bolder;
            }
            .time {
              letter-spacing: 2px;
            }
          }
          .sub-price-area {
            width: 100%;
            display: flex;
            justify-content: center;
            .sub-price {
              width: 130px;
              background-color: #ffeadb;
              font-size: 12px;
              color: #8b3c00;
              text-align: center;
              height: 26px;
              line-height: 26px;
              letter-spacing: 1px;
              border-radius: 13px;
              padding: 0 5px;
            }
          }
        }
        .recharge-card:hover {
          transform: scale(1.1);
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        }
        .recharge-card.active.month {
          border-color: #223dfd;
        }
        .recharge-card.active.year {
          border-color: #ff864b;
        }
      }
      // .recharge-area .active {
      //   background: linear-gradient(
      //     288.44deg,
      //     #eabc88 -18.63%,
      //     #ebbf8d -11.17%,
      //     #fadbaf 1.29%,
      //     #fff1d4 54.41%,
      //     #fffefa 116.17%
      //   );
      // }
      .document-area {
        // margin-left: 5px;
        margin-top: 10px;
      }
      .product-area {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 12px;
        letter-spacing: 1px;
        .text {
          text-decoration: underline;
          cursor: pointer;
          color: #c9c9c9;
          letter-spacing: 1px;
        }
      }
      .QR-code-area {
        background: #fff;
        border: 1px solid #e1e1e1;
        border-radius: 8px;
        color: #676890;
        padding: 12px;
        width: 570px;
        margin-top: 20px;
        display: flex;
        padding-left: 230px;
        justify-content: flex-start;
        .tabs {
          display: flex;
          margin-bottom: 20px;
          .tab {
            background: #fff;
            border: 1px solid #ccc;
            border-radius: 4px;
            padding: 8px;
            cursor: pointer;
            margin-left: 20px;
          }

          .tab.active {
            background: #6182f5;
            color: #fff;
          }
        }
        .content {
          width: 105px;
          padding: 10px 0;
          // height: 120px;
          #wechat-qrcode {
            border: 1px solid #e1e1e1;
          }
          .content-pay-area {
            text-align: center;
            margin-top: 15px;
            i {
              font-size: 18px;
              margin-right: 5px;
            }
            display: flex;
            align-items: center;
            justify-content: center;
            letter-spacing: 2px;
            font-weight: bold;
          }
        }
        .content-desc {
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          .pay-desc {
            margin-bottom: 10px;
            .word {
              color: #2d2d2d;
              font-size: 16px;
              letter-spacing: 1px;
            }
            .unit {
              color: #ff464d;
              font-size: 14px;
              font-weight: bolder;
              letter-spacing: 2px;
            }
            .number {
              color: #ff464d;
              font-size: 22px;
              font-weight: bolder;
              letter-spacing: 2px;
            }
          }
          .sub-desc {
            color: #7f7f7f;
            font-size: 14px;
            letter-spacing: 2px;
          }
        }
      }
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #606266;
    }
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
.vip-dialog {
  .payment-success {
    text-align: center;
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }
  .success-icon {
    font-size: 100px;
    color: #4caf50;
    margin-bottom: 20px;
  }
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  p {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .order-details {
    text-align: left;
    margin: 20px 0;
  }
  .order-details h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .order-details ul {
    list-style: none;
    padding: 0;
  }
  .order-details li {
    margin-bottom: 5px;
  }
  .success-actions {
    margin-top: 20px;
  }
  .success-actions button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
  }
  .success-actions button:hover {
    background-color: #45a049;
  }
  .payment-failure {
    text-align: center;
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }
  .failure-icon {
    font-size: 100px;
    color: #f44336;
    margin-bottom: 20px;
  }
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  p {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .error-details {
    text-align: left;
    margin: 20px 0;
  }
  .error-details h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .actions {
    margin-top: 20px;
  }
  .actions button {
    background-color: #f44336;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
  }
  .actions button:hover {
    background-color: #d32f2f;
  }
}
</style>
